module.exports = __webpack_public_path__ + "static/media/keep-plan-updated.839c382c.png";